module.exports = __webpack_public_path__ + "img/Phone_01.4daa0016.jpg";